import '.c7{position:relative;}.ssr-plugin'
import '.ie{width:64px;}.ssr-plugin'
import '.if{height:64px;}.ssr-plugin'
import '.be{flex-shrink:0;}.ssr-plugin'
import '.av{position:absolute;}.ssr-plugin'
import '.ig{bottom:-4px;}.ssr-plugin'
import '.gs{right:-4px;}.ssr-plugin'
import '.dk{border-radius:50%;}.ssr-plugin'
import '.ih{border:2px solid var(--palette-white);}.ssr-plugin'
import '.ai{overflow:hidden;}.ssr-plugin'
import '.ii{width:32px;}.ssr-plugin'
import '.ij{height:32px;}.ssr-plugin'
import { styled } from 'inlines'
import { Avatar } from '@app/components/core/avatar/Avatar'
import { Image } from '@app/components/core/image/Image'

type ConversationAvatarProps = {
  initiativeImage?: string
  userAvatar?: string
  userName: string
}

export const ConversationAvatar = ({
  initiativeImage,
  userAvatar,
  userName,
}: ConversationAvatarProps) => {
  return (
    <div className="c7 ie if be"
    >
      {initiativeImage ? (
        <Image
          src={initiativeImage}
          resizeWidth={128}
          alt="initiative"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            borderRadius: '12px',
          }}
        />
      ) : (
        <Avatar
          size="medium"
          shape="square"
          labelSource={userName}
          variant="yellow"
        />
      )}
      <div className="av ig gs dk ih ai ii ij"
      >
        <Avatar
          size="extra-small"
          shape="circle"
          image={userAvatar}
          labelSource={userName}
        />
      </div>
    </div>
  )
}
